import * as React from "react";
import PropTypes from "prop-types";

const RcsIcon = ({ width = 18, height = 18, className = "" }) => {
  const gradientId = React.useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" x2="100%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#4a90e2" stopOpacity={1} />
          <stop offset="100%" stopColor="#0052d4" stopOpacity={1} />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradientId})`}
        d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10Z"
      />
      <text
        x={12}
        y={10.5}
        fill="#fff"
        dominantBaseline="middle"
        fontFamily="sans-serif"
        fontSize={6}
        fontWeight="bold"
        textAnchor="middle"
      >
        RCS
      </text>
    </svg>
  );
};

RcsIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
};

export default RcsIcon;
